import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppleIcon, ChromeIcon } from 'lucide-react';
import { EntryLayout } from '../../components/EntryLayout';
import { EntryField } from '../../components/EntryField';
import { Button } from '../../components/ui/Button';
import { useLocale } from '../../contexts/LocaleContext';
import { useSession } from '../../contexts/SessionContext';

/** MOB/Auth/Login. REQUIRES BACKEND: credential validation and session tokens. */
export function Login() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const {
    signIn,
    onboarded
  } = useSession();
  const [email, setEmail] = useState('ana@beelyv.com');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const submit = () => {
    if (!email.includes('@') || password.trim().length < 6) {
      setError(true);
      return;
    }
    signIn();
    navigate(onboarded ? '/' : '/onboarding', {
      replace: true
    });
  };
  const provider = () => {
    signIn();
    navigate(onboarded ? '/' : '/onboarding', {
      replace: true
    });
  };
  return <EntryLayout title={t('entry.login.title')} body={t('entry.login.body')} showBack={false} footer={<>
          <Button variant="gold" size="lg" fullWidth onClick={submit} data-id="element-2392" data-mp="14z3kpdrvvvuy">
            {t('entry.login.submit')}
          </Button>
          <p className="mt-2 text-center text-[12.5px] text-muted" data-id="element-2393" data-mp="19t7sfz8z47x3">
            {t('entry.login.noAccount')}{' '}
            <button type="button" onClick={() => navigate('/criar-conta')} className="font-bold text-gold-deep underline decoration-gold/40 underline-offset-2" data-id="element-2394" data-mp="1irt5jevoeuqh">
              {t('entry.login.create')}
            </button>
          </p>
        </>} data-id="element-2391" data-mp="1011zam6zjkgb">
      <div className="space-y-3" data-id="element-2395" data-mp="3pj2bpveyifye">
        <EntryField label={t('entry.login.email')} type="email" autoComplete="email" value={email} onChange={value => {
        setEmail(value);
        setError(false);
      }} data-id="element-2396" data-mp="3pk3p46jg3eja" />
        <EntryField label={t('entry.login.password')} type="password" autoComplete="current-password" placeholder="••••••••" value={password} onChange={value => {
        setPassword(value);
        setError(false);
      }} error={error ? t('entry.login.invalid') : undefined} data-id="element-2397" data-mp="3ifm25fr0nmir" />
      </div>

      <button type="button" onClick={() => navigate('/recuperar')} className="mt-2 text-[12.5px] font-medium text-gold-deep underline decoration-gold/40 underline-offset-2" data-id="element-2398" data-mp="981kt762w2xx">
        {t('entry.login.forgot')}
      </button>

      <div className="mt-4 flex items-center gap-2" aria-hidden="true" data-id="element-2399" data-mp="e2fi5f4awk58">
        <span className="h-px flex-1 bg-sand-line" data-id="element-2400" data-mp="sxvig1vh5ca2" />
        <span className="bee-overline text-[8.5px] font-bold text-muted" data-id="element-2401" data-mp="syn52n73fzo7">
          {t('entry.login.or')}
        </span>
        <span className="h-px flex-1 bg-sand-line" data-id="element-2402" data-mp="17l3ybfzqa5sd" />
      </div>

      <div className="mt-3 space-y-2" data-id="element-2403" data-mp="17llqa0fcxxuh">
        <Button variant="outline" size="lg" fullWidth onClick={provider} data-id="element-2404" data-mp="1bmp98vspc9zx">
          <AppleIcon size={17} data-id="element-2405" data-mp="1bkl3077byywh" />
          {t('entry.login.apple')}
        </Button>
        <Button variant="outline" size="lg" fullWidth onClick={provider} data-id="element-2406" data-mp="xmehlqjkirdp">
          <ChromeIcon size={17} data-id="element-2407" data-mp="12ky2roqc7z50" />
          {t('entry.login.google')}
        </Button>
      </div>
    </EntryLayout>;
}